import { createClient } from "@supabase/supabase-js";
import { Database } from "../types/supabase";
import { ANON_KEY, PROJECT_URL } from "./supabase-config";

export const supabase = createClient<Database>(PROJECT_URL, ANON_KEY);
